import { UPDATE_APPROVALSTATUS_REQUEST, UPDATE_APPROVALSTATUS_SUCCESS, UPDATE_APPROVALSTATUS_FAIL} from '../types/jobCardTypes';

function updateApprovalStatusReducer( state = { approvalStatus: {} }, action) {
    switch (action.type) {
        case UPDATE_APPROVALSTATUS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_APPROVALSTATUS_SUCCESS: 
            return {
                ...state,
                approvalStatus: action.payload,
                isLoading: false
            }
        case UPDATE_APPROVALSTATUS_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

export { updateApprovalStatusReducer }